import React, { Suspense, LazyExoticComponent, ComponentType } from 'react';
import LoaderSpinner from './LoaderSpinner';

function Loadable<T extends ComponentType<any>>(Component: LazyExoticComponent<T> | T) {
  type Props = T extends ComponentType<infer P> ? P : never;

  return function LoadableComponent(props: Props) {
    return (
      <Suspense
        fallback={
          <div className="flex justify-center items-center fixed h-full w-full">
            <LoaderSpinner className="w-10 h-20" />
          </div>
        }
      >
        <Component {...props} />
      </Suspense>
    );
  };
}

export default Loadable;
